// PDP 3.4 — SETTINGS (layout flags, theme tokens). Shopify: theme/section settings.
// v3/v31/v32/v33/v34 flags select which shared-component treatments render; keep as is.

export const PDP_3_4_SETTINGS = {
  logo: "https://www.riversol.com/cdn/shop/files/Riversol_Logo_2026.svg?v=1770147445&width=200",
  v3: true,
  v31: true,
  v32: true,
  v33: true,
  v34: true,
  showLightComparison: false,
  showBlueComparison: true,
  galleryStickyFirst: false,
  galleryOneSkin: true,
  brandDark: "#003746",
  mediaRadius: "5px",
  howToMediaRadius: "5px",
  titleNoWrap: true,
};

export default PDP_3_4_SETTINGS;
